<template>
<div>
  <div class="mask" v-show="show" @click="show=false"></div>
  <div class="relative">
    <div class="filtrate">
      <span
        v-for="(v,i) in [
          {title:$t('label.w204')},
          {title:$t('label.w205')},
          {title:$t('label.w17')},
          {title:$t('label.w96')}
        ]"
        :key="i"
      >{{v.title}}</span>
      <i class="icon" @click="show=true"></i>
    </div>
    <Row class="filtrate-box" v-show="show">
      <Col span="8">
        <span>{{$t('label.w204')}}</span>
        <Select v-model="rateType">
          <Option :value="v.v" v-for="v in [
            {v:0,n:$t('option.w2')},
            {v:1,n:$t('option.w3')},
            {v:2,n:$t('option.w4')},
            {v:3,n:$t('option.w5')},
          ]" :key="v.v">{{v.n}}</Option>
        </Select>
      </Col>
      <Col span="8">
        <span>{{$t('label.w17')}}</span>
        <Select v-model="loanCycleType">
          <Option :value="v.v" v-for="v in [
            {v:0,n:$t('option.w6')},
            {v:1,n:$t('option.w7')},
            {v:2,n:$t('option.w8')},
            {v:3,n:$t('option.w9')},
            {v:4,n:$t('option.w10')},
            {v:5,n:$t('option.w11')},
          ]" :key="v.v">{{v.n}}</Option>
        </Select>
      </Col>
      <Col span="8">
        <span>{{$t('label.w205')}}</span>
        <Select v-model="amountType">
          <Option :value="v.v" v-for="v in [
            {v:0,n:$t('option.w12')},
            {v:1,n:$t('option.w13')},
            {v:2,n:$t('option.w14')},
            {v:3,n:$t('option.w15')},
          ]" :key="v.v">{{v.n}}</Option>
        </Select>
      </Col>
      <Col span="24">
        <span>{{$t('label.w146')}}</span>
        <div class="DntypeFilter">
          <DntypeFilter ref="DntypeFilter" :check-all-btn-top="-28" @change="v=>pledgeRules=v"/>
        </div>
      </Col>
      <Col span="24" class="button">
      <Button @click="reset">{{$t('btn.b6')}}</Button>
      <Button class="btn"  @click="submit">{{$t('btn.b7')}}</Button>
      </Col>
    </Row>
  </div>
</div>
</template>
<script>
import DntypeFilter from "@/components/dntypeFilter"
export default {
  components:{DntypeFilter},
  data(){
    return {
      show:false,
      rateType:0,
      loanCycleType:0,
      amountType:0,
      pledgeRules:'',
    }
  },
  methods: {
    submit(){
      this.show=false
      this.$emit('change',{
        rateType:this.rateType,
        loanCycleType:this.loanCycleType,
        amountType:this.amountType,
        pledgeRules:this.pledgeRules
      })
    },
    reset(){
      this.rateType=0
      this.loanCycleType=0
      this.amountType=0
      this.$refs.DntypeFilter.clear()
    }
  },
}
</script>
<style lang="less" scoped>
.mask{
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 99;
}
.DntypeFilter{
  width: 478px;
  padding-top: 10px;
}
  .filtrate {
    padding: 0 40px 0 10px;
    position: absolute;
    right: 0;
    top: -55px;
    width: 254px;
    height: 30px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(208, 208, 208, 1);
    span {
      margin: 4px 3px;
      text-align: center;
      display: inline-block;
      width: 44px;
      height: 20px;
      line-height: 20px;
      background: rgba(228, 235, 248, 1);
      border-radius: 2px;
    }
    .icon {
      position: absolute;
      right: 16px;
      top: 5px;
      display: inline-block;
      width: 16px;
      height: 16px;
      opacity: 0.7;
      background: url("../assets/borrow/pic_Shape@2x.png") no-repeat;
      background-size: cover;
      cursor: pointer;
    }
  }
  .filtrate-box {
    position: absolute;
    right: 0;
    top: -5px;
    padding: 30px 10px 20px 30px;
    width: 538px;
    border-radius: 10px 10px 0px 0px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 20px 0px rgba(18, 20, 99, 0.1);
    z-index: 100;
    font-weight: 500;
    color: #7b7b7c;
    &::before {
      display: block;
      content: "";
      position: absolute;
      right: 16px;
      top: -6px;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-bottom: 6px solid rgba(255, 255, 255, 1);
      z-index: 5;
    }
    .button {
      display: flex;
      justify-content: flex-end;
      margin-top: 20px;
      padding-right: 20px;
      /deep/.ivu-btn {
        width: 93px;
        height: 36px;
        color: #7b7b7c;
        border-radius: 20px;
        border: 1px solid rgba(208, 208, 208, 1);
        span {
          vertical-align: baseline;
        }
      }
      .btn {
        margin-left: 20px;
        background: #5e8ffc;
        color: #fff;
        border: 0;
      }
    }
    span {
      margin: 0 0 5px 8px;
    }
    /deep/.ivu-select {
      width: 146px;
      margin-bottom: 30px;
    }
    .textarea {
      width: 478px;
      min-height: 51px;
      background: rgba(242, 244, 249, 1);
      border-radius: 4px;
      .p1 {
        font-size: 14px;
        width: 100%;
        height: 100%;
        line-height: 50px;
        text-align: center;
      }
      .area {
        padding: 18px 10px 0 10px;
        display: flex;
        .area-l {
          width: 72px;
          text-align: right;
          font-size: 14px;
          color: #333;
          font-weight: 500;
          padding-right: 10px;
        }
        .area-r {
          width: 380px;
          .p-text {
            display: inline-block;
            margin: 0 6px 12px 5px;
            height: 20px;
            background: rgba(252, 252, 252, 1);
            border-radius: 4px;
            border: 1px solid rgba(208, 208, 208, 1);
            span {
              margin: 0;
              padding-left: 5px;
              height: 20px;
              line-height: 20px;
            }
            .color-r {
              display: inline-block;
              color: #f08787;
              font-size: 12px;
              cursor: pointer;
              padding: 0 1px 0 5px;
            }
          }
        }
      }
    }
  }
</style>

